import { CasesGeneralFilter } from '../../../../../shared/types/modules/cases-general';

export const initialValues: CasesGeneralFilter = {
    callId: '',
    document: '',
    status: '',
    branch: '',
    policie: '',
    plate: '',
    endCreatedAt: undefined,
    startCreatedAt: undefined,
};
